module.exports = {
    set: (key, value, ttl) => {
        var localStorage = require('local-storage')
        const now = new Date()

        // `item` is an object which contains the original value
        // as well as the time when it's supposed to expire
        const item = {
            value: value,
            expiry: now.getTime() + ttl,
        }
        localStorage.set(key, JSON.stringify(item))
    },
    get: key => {
        var localStorage = require('local-storage')
        const itemStr = localStorage.get(key)
        // if the item doesn't exist, return null
        if (!itemStr) {
            return null
        }
        const item = JSON.parse(itemStr)
        const now = new Date()
        // compare the expiry time of the item with the current time
        if (now.getTime() > item.expiry) {
            // If the item is expired, delete the item from storage
            // and return null
            localStorage.remove(key)
            return null
        }
        return item.value
    },
    remove: key => {
        var localStorage = require('local-storage')
        localStorage.remove(key)
    }
}